import { action } from 'lib/actionHelpers';

const dispatchValidation = (val, validationType, formId, id) => {
  action('uiPatchFormState', {
    formId: formId,
    state: { [validationType]: val },
  });
};

export const validatePassword = ({ formId, value, id, returnBool = false }) => {
  const uniqueCharacterFormat = /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]+/;
  const oneDigitFormat = /[0-9]/;
  const upperCaseLetterFormat = /[A-Z]/;
  const localValidationCheck = { passwordLengthIsValid: false, passwordUniqueCharacterExists: false, passwordDigitExists: false, passwordUppercaseLetterExists: false };

  if (value.length > 7) {
    dispatchValidation(true, 'passwordLengthIsValid', formId, id);
    localValidationCheck.passwordLengthIsValid = true;
  }

  if (value.length < 8) {
    dispatchValidation(false, 'passwordLengthIsValid', formId, id);
    localValidationCheck.passwordLengthIsValid = false;
  }

  if (uniqueCharacterFormat.test(value)) {
    dispatchValidation(true, 'passwordUniqueCharacterExists', formId, id);
    localValidationCheck.passwordUniqueCharacterExists = true;
  } else {
    dispatchValidation(false, 'passwordUniqueCharacterExists', formId, id);
    localValidationCheck.passwordUniqueCharacterExists = false;
  }

  if (upperCaseLetterFormat.test(value)) {
    dispatchValidation(true, 'passwordDigitExists', formId, id);
    localValidationCheck.passwordDigitExists = true;
  } else {
    dispatchValidation(false, 'passwordDigitExists', formId, id);
    localValidationCheck.passwordDigitExists = false;
  }

  if (oneDigitFormat.test(value)) {
    dispatchValidation(true, 'passwordUppercaseLetterExists', formId, id);
    localValidationCheck.passwordUppercaseLetterExists = true;
  } else {
    dispatchValidation(false, 'passwordUppercaseLetterExists', formId, id);
    localValidationCheck.passwordUppercaseLetterExists = false;
  }
  if (returnBool) {
    return Object.entries(localValidationCheck).filter((item) => item[1] !== true).length === 0 ? true : false;
  }
};
